// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"a74d1a76","239":"60216727","344":"b04bc4dc","451":"60a6b6ed","455":"615daae6","809":"4bfbe1d8","977":"ffd0d9da"}[chunkId] + ".chunk.js";
};